import React from "react";
import "./NoOrganization.scss";
import { GlobalOutlined, SearchOutlined } from "@ant-design/icons";

const NoOrganization: React.FC = () => {
  return (
    <div className="no-org">
      <div className="no-org__spacer" />

      <main className="no-org__main">
        <div className="no-org__content">
          <div className="no-org__icon-wrapper">
            <div className="no-org__icon-bg no-org__icon-bg--rotate" />
            <div className="no-org__icon-bg no-org__icon-bg--border" />

            <div className="no-org__icon-inner">
              <GlobalOutlined className="no-org__icon" />

              <div className="no-org__badge">
                <SearchOutlined className="no-org__badge-icon" />
              </div>
            </div>
          </div>

          <div className="no-org__text">
            <h1 className="no-org__title">Organization Not Found</h1>
            <p className="no-org__description">
              No organization found with this domain. Please check the URL or
              contact your administrator.
            </p>
          </div>
        </div>
      </main>

      <footer className="no-org__footer">
        <div className="no-org__brand">
          <img
            src="/images/qualifyme_light.png"
            alt="QualifyMe Logo"
            className="no-org__brand-logo"
          />
          <span className="no-org__brand-name">QualifyMe</span>
        </div>
      </footer>

      <div className="no-org__bg" aria-hidden="true">
        <div className="no-org__bg-circle no-org__bg-circle--top" />
        <div className="no-org__bg-circle no-org__bg-circle--bottom" />
      </div>
    </div>
  );
};

export default NoOrganization;
